var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FEFCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3774 9.42549C26.4942 9.54265 26.5598 9.70132 26.5598 9.86674C26.5598 10.0322 26.4942 10.1908 26.3774 10.308L25.0736 11.613L22.5736 9.11299L23.8774 7.80799C23.9946 7.69082 24.1535 7.625 24.3193 7.625C24.485 7.625 24.6439 7.69082 24.7611 7.80799L26.3774 9.42424V9.42549ZM24.1899 12.4955L21.6899 9.99549L13.1736 18.513C13.1048 18.5818 13.0531 18.6657 13.0224 18.758L12.0161 21.7755C11.9979 21.8305 11.9953 21.8895 12.0087 21.9459C12.022 22.0023 12.0508 22.0539 12.0918 22.0949C12.1328 22.1358 12.1843 22.1646 12.2407 22.178C12.2971 22.1913 12.3561 22.1887 12.4111 22.1705L15.4286 21.1642C15.5208 21.1339 15.6047 21.0826 15.6736 21.0142L24.1899 12.4955Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 23.875C8.25 24.3723 8.44754 24.8492 8.79917 25.2008C9.15081 25.5525 9.62772 25.75 10.125 25.75H23.875C24.3723 25.75 24.8492 25.5525 25.2008 25.2008C25.5525 24.8492 25.75 24.3723 25.75 23.875V16.375C25.75 16.2092 25.6842 16.0503 25.5669 15.9331C25.4497 15.8158 25.2908 15.75 25.125 15.75C24.9592 15.75 24.8003 15.8158 24.6831 15.9331C24.5658 16.0503 24.5 16.2092 24.5 16.375V23.875C24.5 24.0408 24.4342 24.1997 24.3169 24.3169C24.1997 24.4342 24.0408 24.5 23.875 24.5H10.125C9.95924 24.5 9.80027 24.4342 9.68306 24.3169C9.56585 24.1997 9.5 24.0408 9.5 23.875V10.125C9.5 9.95924 9.56585 9.80027 9.68306 9.68306C9.80027 9.56585 9.95924 9.5 10.125 9.5H18.25C18.4158 9.5 18.5747 9.43415 18.6919 9.31694C18.8092 9.19973 18.875 9.04076 18.875 8.875C18.875 8.70924 18.8092 8.55027 18.6919 8.43306C18.5747 8.31585 18.4158 8.25 18.25 8.25H10.125C9.62772 8.25 9.15081 8.44754 8.79917 8.79917C8.44754 9.15081 8.25 9.62772 8.25 10.125V23.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.71d04bb1fa938ba88665dbf523d4e07e.svg";
export { ForwardRef as ReactComponent };